import store from '@/store/store';
import { formatSpaceSizeLabel } from '@/bundles/MeasurementUnits/helpers';

// Land sizes are stored in SF and shown in the account's land size unit. LandSizeLabel builds its label
// from this and adds the second unit for large or small sizes; this returns the account unit only.
export const getLandSizeFormatted = (value: number | string, cutZero = true): string => {
  const defaultLandSizeUnit = store.state.MeasurementUnits.landSize;
  const selectedLandSizeUnit = store.state.accountSettings?.properties?.land_size_type?.value;

  return formatSpaceSizeLabel(value, {
    from: defaultLandSizeUnit,
    to: selectedLandSizeUnit,
  }, { cutZero });
};
